async function fetchData(url) {
  try {
    const response = await fetch(url);

    const data = await response.text();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}
function disableSubmitButton(input) {
  if (!input) return;
  let parentContainer =
    input.parentElement.parentElement.parentElement.parentElement;
  if (parentContainer) {
    let quantityInputBtn =
      parentContainer.previousElementSibling.querySelector("input");
    if (!quantityInputBtn) return;
    let productCartValue = Number(quantityInputBtn.dataset.cartQuantity);
    let availableProductValue = Number(
      quantityInputBtn.dataset.variantInventoryQty
    );
    if (productCartValue == availableProductValue) {
      input.classList.add("disabled");
      input.setAttribute("disabled", true);
    } else {
      input.classList.remove("disabled");
      input.removeAttribute("disabled", true);
    }
  }
}
// Function to replace content in an element with a specific ID
function replaceContent(elementId, newData) {
  const element = document.getElementById(elementId);
  let parser = new DOMParser();
  let parsedData = parser.parseFromString(newData, "text/html");
  const renderData = parsedData.getElementById(elementId);

  if (element && renderData) {
    element.replaceWith(renderData);
  } else {
    console.error("Element with ID " + elementId + " not found.");
  }
}

function removeFreeProduct() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const productHandles = cart.items.map((item) => ({
        handle: item.handle,
        lineItemKey: item.key,
      }));
      const productPromises = productHandles.map((handleObj) =>
        fetch(`/products/${handleObj.handle}.js`).then((response) =>
          response.json().then((product) => ({
            ...product,
            lineItemKey: handleObj.lineItemKey,
          }))
        )
      );

      Promise.all(productPromises).then((products) => {
        const productTags = products.map((product) => ({
          id: product.id,
          tags: product.tags,
          handle: product.handle,
          quantity: cart.items.find((item) => item.handle === product.handle)
            .quantity,
          lineItemKey: product.lineItemKey,
        }));
        for (let i = 0; i < productTags.length; i++) {
          let item = document.querySelector(
            `.${CSS.escape(productTags[i].lineItemKey)}`
          );
          if (
            item.querySelector(".quantity__input")?.dataset
              ?.variantInventoryQty == 0
          ) {
            removeSampleProduct(productTags[i], productTags[i].quantity);
            //
          }
        }
      });
    });
}
removeFreeProduct();

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");
        let addSampleBtns = document.querySelectorAll(
          ".oj-complimentary-samples__wrapper .quick-add__submit"
        );
        addSampleBtns.forEach((btn) => {
          btn.classList.add("disabled");
          btn.setAttribute("disabled", true);
        });
        const config = window.fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              window.publish(window.PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });

            // Fire AddToCart tracking events
            try {
              var variantId = formData.get("id");
              var quantity = parseInt(formData.get("quantity")) || 1;
              var productTitle = document.querySelector('.product__title')?.textContent?.trim() || 'Product';

              // Shopify cart/add response has: price (per unit), line_price, final_line_price (all in cents)
              // Use final_line_price if available (includes discounts), otherwise calculate from price
              var productPrice = response.final_line_price || response.line_price || (response.price * quantity) || 0;
              var priceValue = productPrice / 100; // Convert from cents to dollars

              // Always use USD for Meta Pixel tracking (base currency)
              var currency = 'USD';

              console.log('[Tracking] AddToCart data:', {
                variantId: variantId,
                quantity: quantity,
                productTitle: productTitle,
                rawPrice: productPrice,
                priceValue: priceValue,
                currency: currency,
                fullResponse: response
              });

              // Meta Pixel - AddToCart (using trackSingle to ensure ALL data is sent to our specific pixel)
              // Pixel ID: 851309100851305
              if (typeof fbq === 'function') {
                fbq('trackSingle', '851309100851305', 'AddToCart', {
                  content_ids: [String(variantId)],
                  content_type: 'product',
                  content_name: productTitle,
                  value: priceValue,
                  currency: currency
                });
                console.log('%c[Tracking] Meta Pixel AddToCart fired with value: ' + priceValue + ' ' + currency, 'background: #4267B2; color: white; padding: 2px 6px; border-radius: 3px;');
              }

              // Google Analytics / Google Ads - add_to_cart
              if (typeof gtag === 'function') {
                gtag('event', 'add_to_cart', {
                  currency: currency,
                  value: priceValue,
                  items: [{
                    item_id: String(variantId),
                    item_name: productTitle,
                    quantity: quantity,
                    price: priceValue / quantity
                  }]
                });
                console.log('%c[Tracking] GA4 add_to_cart fired', 'background: #4285F4; color: white; padding: 2px 6px; border-radius: 3px;');
              }
            } catch (trackingError) {
              console.warn('[Tracking] AddToCart error:', trackingError);
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .then(function (result) {
            const urlToFetch = window.location.pathname;

            fetchData(urlToFetch).then((fetchedData) => {
              // Replace the content of the element with the fetched data
              // Replace the first argument with the ID you want to replace

              replaceContent("cart_drawer", fetchedData);
              replaceContent("cart_page", fetchedData);
            });
            // .finally(() => {
            // 	// updatePrices();
            // });
            // sampleProduct();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
            // let addSampleBtns = document.querySelectorAll('.oj-complimentary-samples__wrapper .quick-add__submit');
            // addSampleBtns.forEach((btn) => {
            // 	btn.classList.remove('disabled');
            // 	btn.removeAttribute('disabled');
            // })
          });
        setTimeout(() => {
          disableSubmitButton(this.submitButton);
        }, 2500);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
document.addEventListener("DOMContentLoaded", function () {
  productSubmitBtn = document.querySelector(".product-form__buttons button");
  disableSubmitButton(productSubmitBtn);
});
